module.exports = __webpack_public_path__ + "media/images/convenios/cons_prof_ing_arq_agr-5d5a71e018139e497b050343fbda420d.jpg";